import { render } from "./UserChangePasswordOffcanvas.vue?vue&type=template&id=44574fb8&scoped=true"
import script from "./UserChangePasswordOffcanvas.vue?vue&type=script&lang=js"
export * from "./UserChangePasswordOffcanvas.vue?vue&type=script&lang=js"

import "./UserChangePasswordOffcanvas.vue?vue&type=style&index=0&id=44574fb8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44574fb8"]])

export default __exports__